import React, {Fragment} from "react";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";


const ContractsPopupSuccess = (props) => {

  const {fabricatorData, agreeEmailCheckbox, customerEmail, signedDocumentUrl, closeSignPopup} = props;

  const showEmail = agreeEmailCheckbox && !fabricatorData.disableCustomerEmails;

  const finishClick = () => {
    closeSignPopup();
  }

    // LoadingSpinner
  return (
    <Fragment>
      <div className="contract-popup__success">
        <div className="contract-success">
          <p className="contract-success__text">
            <FormattedMessage
              id={showEmail ? "contractSign.contractSuccessText" : "contractSign.contractSuccessTextWithoutEmail"}/>
          </p>
          {showEmail ? <p className="contract-success__email bold">{customerEmail}</p> : null}
          <br/>
          {signedDocumentUrl ? (
            <p className="contract-success__email bold">
              <button className="ui-button2 ui-button2--green ui-button3--wide"
                      onClick={() => window.open(signedDocumentUrl, "_blank")}>
                <FormattedMessage id="contractSign.downloadButton"/>
              </button>
            </p>
          ) : null}
        </div>
      </div>
      <div className="contract-popup__footer" style={{paddingRight: "40px"}}>
        <div className="ui-popup__footer-left"/>
        <div className="ui-popup__footer-right">
          <button className="ui-button2 ui-button2--green ui-button3--wide"
                  onClick={finishClick}>
            <FormattedMessage id="contractSign.footerCloseButton"/>
          </button>
        </div>
      </div>
    </Fragment>
  )
};

ContractsPopupSuccess.propTypes = {
  closeSignPopup: PropTypes.func.isRequired,
}

const mapStateToProps = (store) => {
  const {signedDocumentUrl} = store.contractSigningState;
  const {agreeEmailCheckbox} = store.serverState;
  const {userInfo} = store.userState;

  return {
    signedDocumentUrl,
    fabricatorData: store.fabricatorState,
    agreeEmailCheckbox,
    customerEmail: userInfo.email,
  };
};

export default connect(mapStateToProps)(ContractsPopupSuccess)
